export default "__VITE_ASSET__Bic1wULX__"